import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "f026354a-d36a-47bf-953f-de3cbbb01a3e",
    content: "0.5 m/s",
    options: {},
  },
  {
    id: "5951a0ff-47ac-4838-b6df-c8667a6f213d",
    content: "2 m/s",
    options: {},
  },
  {
    id: "37f90d36-0686-499f-a504-83f809ef84e2",
    content: "8 m/s",
    options: {},
  },
  {
    id: "ceb4074b-42ca-4486-9fb1-96748cf34d80",
    content: "1 m/s",
    options: {},
  },
  {
    id: "7e13e7ec-1b5f-4a73-8c7b-dd074e3dff27",
    content: "4 m/s",
    options: {},
  },
  {
    id: "863e63ca-5df4-4122-9dbf-3fa155752c10",
    content: "10 m/s",
    options: {},
  },
];

export const task: Task = {
  id: "626c749f-cd1d-4bfa-8243-08d608551f19",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["7e13e7ec-1b5f-4a73-8c7b-dd074e3dff27"],
};
